<template>
<v-container>
        <v-row justify="center">
          <v-col cols="12" md="8" class="text-center">

            <h2 class="font-weight-bold mb-6" style="font-size: 2rem; text-wrap: balance">
              Prepárate para la Selectividad con la potencia de la IA
            </h2>
            <p class="solution-subtitle mb-12"
              style="font-size: 1.1rem; color: #616161; max-width: 700px; margin-left: auto; margin-right: auto;">
              SeleAI convierte tus apuntes en herramientas de estudio optimizadas para aprobar la Selectividad con éxito.
            </p>
          </v-col>
        </v-row>

        <!-- Features -->
        <v-row class="features-row mb-12">
          <v-col cols="12" md="6" order="1" order-md="1"  class="d-flex flex-column justify-center">
            <div class="feature-content pr-md-8">
              <div class="badge-wrapper mb-4">
                <div class="badge feature-badge">
                  <lucide-help-circle :size="13" class="mr-1" style="width: 13px; height: 13px"></lucide-help-circle>
                  <span>Simulacros de Examen</span>
                </div>
              </div>
              <h3 class="font-weight-bold mb-4" style="font-size: 1.4rem; text-wrap: balance">
                Practica con exámenes reales de Selectividad
              </h3>
              <p class="mb-6" style="font-size: 1rem; color: #616161; line-height: 1.7;">
                Genera cuestionarios con el formato exacto de los exámenes PAU/EBAU. Personaliza por materia y comunidad autónoma.
              </p>
    
            </div>
          </v-col>
          <v-col cols="12" md="6" order="2" order-md="2">
            <div class="feature-image">
              <video src="../../../assets/features/quiz.mp4" alt="Simulacros de Selectividad en SeleAI"
                style="width: 100%; height: 100%;"
                :style="$vuetify.breakpoint.xs ? 'rotate: 0deg;' : 'rotate: 3deg;'"
                class="feature-screenshot py-2 rounded-xl" autoplay muted loop></video>
            </div>
          </v-col>
        </v-row>

        <v-row class="features-row mb-12">
          <v-col cols="12" md="6" order="2" order-md="1" class="mb-8 mb-md-0">
            <div class="feature-image">
              <img src="../../../assets/features/summary-screenshot.png" alt="Resúmenes de Selectividad en SeleAI"
                class="feature-screenshot py-3 rounded-xl"
                :style="$vuetify.breakpoint.xs ? 'rotate: 0deg;' : 'rotate: -3deg;'"
                ></img>
            </div>
          </v-col>
          <v-col cols="12" md="6" order="1" order-md="2" class="d-flex flex-column justify-center">
            <div class="feature-content pl-md-8">
              <div class="badge-wrapper mb-4">
                <div class="badge feature-badge">
                  <lucide-file-text :size="16" class="mr-1" style="width: 13px; height: 13px;"></lucide-file-text>
                  <span>Resúmenes por Materia</span>
                </div>
              </div>
              <h3 class="font-weight-bold mb-4" style="font-size: 1.4rem; text-wrap: balance">
                Domina cada asignatura de Selectividad
              </h3>
              <p class="mb-6" style="font-size: 1rem; color: #616161; line-height: 1.7;">
                Convierte tus apuntes en resúmenes organizados por temas, destacando lo que más puntúa en cada asignatura.
              </p>
    
            </div>
          </v-col>
        </v-row>

        <v-row class="features-row">
          <v-col cols="12" md="6" order="1" order-md="1"  class="d-flex flex-column justify-center"">
            <div class="feature-content pr-md-8 my-auto">
              <div class="badge-wrapper mb-4">
                <div class="badge feature-badge">
                  <lucide-layers :size="13" class="mr-1" style="width: 13px; height: 13px;"></lucide-layers>
                  <span>Flashcards para Memorizar</span>
                </div>
              </div>
              <h3 class="font-weight-bold mb-4" style="font-size: 1.4rem; text-wrap: balance">
                Memoriza fechas, fórmulas y conceptos clave
              </h3>
              <p class="mb-6" style="font-size: 1rem; color: #616161; line-height: 1.7;">
                Retén toda la información crucial para la Selectividad con tarjetas de repaso optimizadas para cada asignatura.
              </p>
        
        
            </div>
          </v-col>
          <v-col cols="12" md="6" order="2" order-md="2">
            <div class="feature-image">
              <video src="../../../assets/features/flashcards.mp4" alt="Flashcards para Selectividad en SeleAI"
                style="width: 100%; height: 100%;"
                :style="$vuetify.breakpoint.xs ? 'rotate: 0deg;' : 'rotate: 3deg;'"
                class="feature-screenshot rounded-xl" autoplay muted loop></video>
            </div>
          </v-col>
        </v-row>
      </v-container>
</template>


<script>
import { HelpCircle, FileText, Layers } from 'lucide-vue'

export default {
  name: 'SolutionsSection',
  components: {
    LucideHelpCircle: HelpCircle,
    LucideFileText: FileText,
    LucideLayers: Layers
  },
  data() {
    return {
    }
  }
}
</script>


<style scoped>

/* Mejoras en el estilo de las screenshots */
.feature-screenshot {
  border-radius: 20px;
  box-shadow: 0 12px 24px rgba(0, 0, 0, 0.04);
  border: 1px solid #f0f0f0;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.feature-image >>> img {
    max-height: 300px;
    object-fit: contain;
}

.feature-image:hover .feature-screenshot {
  transform: scale(1.01);
  box-shadow: 0 12px 24px rgba(0, 0, 0, 0.08);
}

.feature-badge {
  color: #16260e;
  background: white;
  border: 1px solid #ececec;
  display: flex;
  align-items: center;
  justify-content: center;
}


.feature-badge svg {
  margin: auto;
}


/* Estilo para listas */
.feature-list {
  list-style-type: none;
  padding-left: 0;
}

.feature-list li {
  margin-bottom: 12px;
  display: flex;
  align-items: flex-start;
}

.feature-list li span {
  font-size: 0.8rem;
  font-weight: 500;
  color: #4b4b4b;
  padding-top: 2px;
}

/* Estilos importados de HomePage.vue */
h1, h2, h3, h4, .text-h1, .text-h2, .text-h3, .text-h4 {
  font-family: "Nunito", "DINRounded", "Inter", sans-serif !important;
  font-weight: 900 !important;
  color: #4b4b4b !important;
  letter-spacing: -0.03em !important;
  text-wrap: balance;
}

.subtitle-1, p, span, div {
  font-family: "Nunito", "DINRounded", "Inter", sans-serif !important;
  color: #4b4b4b;
}

/* Badges de Duolingo */
.solution-badge, .examples-badge, .feature-badge, .pricing-badge {
  background: #fff;
  color: #4dd453;
  border-radius: 16px;
  padding: 4px 8px;
  font-weight: 600;
  font-size: 14px;
  display: flex;
  align-content: center;
  justify-content: center;
  width: fit-content;
  border: 1px solid #e9e9e9
}

.badge-wrapper {
  display: flex;
  align-content: center;
  justify-content: center;
}

/* Estilos para iconos Lucide */
.lucide {
  stroke-width: 1.5;
  width: 24px;
  height: 24px;
}

/* Tamaños específicos */
.lucide.lucide-small {
  width: 16px;
  height: 16px;
}

.lucide.lucide-medium {
  width: 20px;
  height: 20px;
}

.lucide.lucide-large {
  width: 32px;
  height: 32px;
}

/* Mejoras para el contenido de características */
.feature-content {
  text-align: center;
}

@media (min-width: 960px) {
  .feature-content {
    text-align: left;
  }
  
  .badge-wrapper {
    justify-content: flex-start;
  }
}

/* Estilos responsivos */
@media (max-width: 959px) {
  h2, .text-h2 {
    font-size: 2rem !important;
  }
  
  h3, .text-h3 {
    font-size: 1.3rem !important;
  }
}

</style>